import { NgModule } from '@angular/core';
import { UiModule } from '../../../../ui/ui.module';
import { OfferCalculatorPaymentScheduleComponent } from './offer-calculator-payment-schedule.component';
import { OfferPaymentScheduleTableComponent } from './offer-payment-schedule-table/offer-payment-schedule-table.component';

@NgModule({
	imports: [
		UiModule,
	],
	declarations: [
		OfferCalculatorPaymentScheduleComponent,
		OfferPaymentScheduleTableComponent
	],
	exports: [
		OfferCalculatorPaymentScheduleComponent
	],
})
export class OfferCalculatorPaymentScheduleModule { }
